import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BroadcastService {
    private channel!: BroadcastChannel;
    private proceed: boolean = true;

    constructor() {
        this.createBroadcastChannel(); // Create the channel initially
    }

    private createBroadcastChannel() {
        this.channel = new BroadcastChannel('excel_addin_channel');
    }

    public async initializeBroadcastChannel(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            this.createBroadcastChannel(); // Ensure channel exists

            // Notify other instances that this add-in is opened
            this.channel.postMessage('addinOpened');

            // Listen for messages from other instances
            this.channel.onmessage = (event) => {
                if (event.data === 'addinOpened') {
                    // Another instance is already opened
                    this.channel.postMessage('close');
                }
                else if (event.data === 'addinClosed') {
                    this.proceed = true;
                }
                if (event.data === 'close') {
                    this.proceed = false;
                }
            };

            setTimeout(() => { resolve(this.proceed); }, 500);
        });
    }

    public closeBroadcastChannel() {
        if (this.channel) {
            this.channel.postMessage('addinClosed');
            this.channel.close();
        }
    }

    public reopenBroadcastChannel() {
        this.createBroadcastChannel();
    }

}
